import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CONFIG } from '@frontend/config';
import { catalogAdminPath, useCatalogAdminCapability } from '@frontend/features/hotel-catalog-admin/queries';
import { HotelSearchPolicy } from '@frontend/features/hotel-search-policy/HotelSearchPolicy';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Paper, Typography, Tabs, Tab } from '@mui/material';
import { HotelConnections } from '@frontend/features/hotels/HotelConnections';

export const AgencyHotelConnections = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const catalogAdmin = useCatalogAdminCapability();
  const [section, setSection] = useState('search');
  const hasCatalog = catalogAdmin.data?.allowed && Number(id) === Number(CONFIG.AGENCY_ID);
  const activeSection = section === 'catalog' && !hasCatalog ? 'search' : section;
  return (
    <Box
      sx={{
        p: { xs: 2, md: 3 },
        width: '100%',
        minWidth: 0,
        maxWidth: 1200,
        boxSizing: 'border-box',
        overflowWrap: 'anywhere',
      }}
    >
      <Typography variant="h5">{t('hotelSettings.title')}</Typography>
      <Typography color="text.secondary" sx={{ mt: 1 }}>
        {t('hotelSettings.description')}
      </Typography>
      <Tabs
        value={activeSection}
        onChange={(_, value) => setSection(value)}
        variant="scrollable"
        scrollButtons="auto"
        aria-label={t('hotelSettings.title')}
        sx={{ my: 3 }}
      >
        <Tab
          value="search"
          label={t('hotelSettings.search')}
          id="hotel-search-tab"
          aria-controls="hotel-search-panel"
        />
        <Tab
          value="connections"
          label={t('hotelSettings.connections')}
          id="hotel-connections-tab"
          aria-controls="hotel-connections-panel"
        />
        {hasCatalog && (
          <Tab
            value="catalog"
            label={t('hotelSettings.catalog')}
            id="hotel-catalog-tab"
            aria-controls="hotel-catalog-panel"
          />
        )}
      </Tabs>
      <Box
        role="tabpanel"
        id="hotel-search-panel"
        aria-labelledby="hotel-search-tab"
        hidden={activeSection !== 'search'}
      >
        <HotelSearchPolicy key={`policy-${id}`} agencyId={Number(id)} />
      </Box>
      <Box
        role="tabpanel"
        id="hotel-connections-panel"
        aria-labelledby="hotel-connections-tab"
        hidden={activeSection !== 'connections'}
      >
        <HotelConnections key={id} agencyId={Number(id)} />
      </Box>
      <Box
        role="tabpanel"
        id="hotel-catalog-panel"
        aria-labelledby="hotel-catalog-tab"
        hidden={activeSection !== 'catalog'}
      >
        {hasCatalog && (
          <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
            <Typography variant="h6">{t('hotelCatalogAdmin.title')}</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ my: 1 }}>
              {t('hotelDestinationOrder.agencyDescription')}
            </Typography>
            <Button variant="outlined" onClick={() => navigate(catalogAdminPath)}>
              {t('hotelDestinationOrder.title')}
            </Button>
          </Paper>
        )}
      </Box>
    </Box>
  );
};
